// extracted by mini-css-extract-plugin
export default {"only-title-sticky-header":"OnlyTitleStickyHeader_only-title-sticky-header__ZvOBc","title":"OnlyTitleStickyHeader_title__-wQBA"};